import { Text, View, StyleSheet, Pressable, Image } from "react-native";
import { discounts_4schools_image_path } from "../../../store/api";
const FilteredDiscounts = ({ allDiscounts, selectedFilters, navigation }) => {
	const filtered = allDiscounts.filter(item => {
		const isCategory = selectedFilters.category
			? selectedFilters.category === "Todas"
				? true
				: item.category?.includes(selectedFilters.category)
			: true;
		const isRegion = selectedFilters.region
			? selectedFilters.region === "Todas"
				? true
				: item.region?.includes(selectedFilters.region)
			: true;
		const isStoreType = selectedFilters.storeType
			? selectedFilters.storeType === "Todas"
				? true
				: item.type?.includes(selectedFilters.storeType)
			: true;
		return isCategory && isRegion && isStoreType;
	});
	return (
		<View style={styles.container}>
			<View style={styles.scrollViewContianer}>
				{filtered.map(item => {
					return (
						<Pressable
							style={styles.item}
							onPress={() => {
								navigation.navigate("SpecificDiscount", {
									info: item,
									navigation: navigation,
								});
								console.log(discounts_4schools_image_path + item.logo_image_id);
							}}
						>
							<Image
								style={styles.image}
								source={{
									uri: discounts_4schools_image_path + item.logo_image_id,
								}}
							/>
							<Text
								style={{
									color: item.title_color,
									fontSize: 12,
									lineHeight: 16,
									marginTop: 20,
									fontFamily: "DmSans-bold",
								}}
							>
								{item.company_name}
							</Text>
							<Text style={styles.description}>{item.title}</Text>
						</Pressable>
					);
				})}
			</View>
		</View>
	);
};
export default FilteredDiscounts;
const styles = StyleSheet.create({
	container: {
		marginBottom: 50,
	},
	item: {
		width: "45%",
		height: 192,
		overflow: "hidden",
		borderRadius: 20,
		backgroundColor: "#fff",
		paddingTop: 20,
		paddingHorizontal: 15,
		marginBottom: 15,
	},
	image: { height: 60, resizeMode: "contain" },
	scrollViewContianer: {
		flexWrap: "wrap",
		flexDirection: "row",
		width: "100%",
		marginBottom: 70,
		justifyContent: "space-evenly",
		marginTop: 25,
	},
	description: {
		color: "#000",
		marginTop: 12,
		fontWeight: "400",
		fontSize: 16,
		lineHeight: 16,
		fontFamily: "DmSans",
	},
});
